const _config = require('./config');

const configs = () => {
    let _randomUrl = Math.floor(Math.random() * 9999 + 1);
    let _c = {
        randomUrl: _randomUrl,
        noPhoto: '/catalogo/assets/img/vehicle_no_photo.png',
        badge: '/catalogo/assets/img/badge.png',
        iconWebmotors: '/catalogo/assets/img/webmotors.webp',
        iconMeucarango: '/catalogo/assets/img/channels/meucarango-wm.svg',
        iconCompreauto: '/catalogo/assets/img/channels/compreauto-wm.svg',
        userPhoto: '/catalogo/assets/img/photo-default-user.webp',
        userIcon: '/catalogo/assets/img/icon/icon-user-login.svg',
        photosGigant: 'gigante/',
        photoSearchResultBig: '?s=fill&w=320&h=240&q=70&t=true',
        photoSearchResultMedium: '?s=fill&w=209&h=164&q=70',
        photoSearchResultLittle: '?s=fill&w=90&h=70&q=70',
        photoDetailBig: '?s=fill&w=1920&h=1440&q=75',
        photoDetailMedium: '?s=fill&w=552&h=414&q=60',
        photoDetailLittle: '?s=fill&w=75&h=56&q=60',
        orderfilter: 1,
        actualPage: 1,
        displayPerPage: 24,
        userProperties: 'webmotors.user.properties',
        callMeBack: {
            name: 'Call Me Back',
            enabled: true,
            productCodes: ['1805'],
            productCodesExceeded: ['1785', '1803'],
            productCodesNoMask: undefined,
        },
        system: 'WebMotors',
        urlUber:
            'https://www.uber.com/a/drive-pp?irgwc=1&utm_term=U-gxxNzhoxyJR5K0JSywsQuwUklxpARe90WF2U0&adg_id=324858&cid=1389457&utm_content=&utm_campaign=affiliate-ir-Webmotors-Brazil_25_-99_national_d_all_acq_cpa_en&utm_source=affiliate-ir',
        urlAPM: 'https://apm.wmaws.com.br',
        urlAppIphone: 'https://itunes.apple.com/br/app/webmotors-comprar-e-vender/id496509047?mt=8',
        urlAppAndroid: 'https://play.google.com/store/apps/details?id=hands.android.webmotors&hl=pt_BR',
        urlSantander: 'https://www.santander.com.br/',
        urlMeuCarango: 'https://www.meucarango.com.br/',
        urlCompreAuto: 'https://www.compreauto.com.br/',
        urlCarSales: 'https://www.carsales.com.au/',
        urlChileAutos: 'https://www.chileautos.cl/',
        urlDeMotores: 'https://www.demotores.com.ar/',
        urlSoloAutos: 'https://www.soloautos.mx/',
        urlAutoCompara: 'https://www.autocompara.com.br/br/web/wcsbrautocomlr/faca-sua-cotacao',
        urlTyreSales: 'https://www.tyresales.com.au/',
        urlTwitter: 'https://twitter.com/webmotors',
        urlFacebook: 'https://www.facebook.com/webmotors',
        urlInstagram: 'https://www.instagram.com/webmotors/',
        urlYoutube: 'https://www.youtube.com/webmotors',
        urlInstitutional: 'https://institucional.webmotors.com.br/',
        urlConsumerProtection: 'https://cdn.webmotors.com.br/webmotors/Content/pdf/cdc.pdf?v=32673',
        urlWorkWithUs: 'https://rh.webmotors.com.br/trabalhe-com-a-gente/',
        urlPublicity: 'https://publicidade.webmotors.com.br/',
        urlContatcUs: 'https://ajuda.webmotors.com.br/hc/pt-br/',
        urlGeneralQuestions: 'https://ajuda.webmotors.com.br',
        urlHowToSell: 'https://atendimento.webmotors.com.br/como-vender-seu-veiculo',
        urlHowToBuy: 'https://atendimento.webmotors.com.br/como-comprar-seu-veiculo',
        urlLegalPerson: 'https://ajuda.cockpit.com.br/hc/articles/360057303832-Quem-pode-anunciar-como-pessoa-juridica',
        urlYourStore: 'https://ajuda.cockpit.com.br/hc/pt-br/',
        urlAutoInsights: 'https://autoinsights.webmotors.com.br/',
        urlAboutUs: 'https://www.webmotors.com.br/institucional/sobre-nos/',
        useSSR: false,
        urlApi: '',
        urlApiServer: '',
        urlApiSantander: '',
        urlApiSantanderServer: '',
        urlWebApp: '',
        photosBikeUrlNew: '',
        photosBikeUrlUsed: '',
        photosUrlUsed: '',
        photosUrlNew: '',
        urlCertifiedPurchase: '',
        urlSellMyCar: '',
        urlSellMyBike: '',
        urlTableFipe: '',
        urlKM: '',
        urlFinancig: '',
        urlConsortium: '',
        urlPortal: 'https://www.webmotors.com.br/wm1',
        urlNewsWM1: '',
        urlNewsWM1Tests: '',
        urlNewsWM1Comparative: '',
        urlNewsWM1Videos: '',
        urlNewsWM1Motorcycles: '',
        urlNewsWM1Secrets: '',
        urlNewsWM1Tips: '',
        urlNewsWM1Pocket: '',
        urlMyAdverts: '',
        urlEditProfile: '',
        urlMyNegotiations: '',
        urlChat: '',
        urlProducts: '',
        urlPosts: '',
        urlAdvancedSearch: '',
        urlUsedOrNewCars: '',
        urlNewCars: '',
        urlUsedOrNewMotorbikes: '',
        urlNewMotorsbike: '',
        urlAutoPayment: '',
        urlManageMyAdvertising: '',
        urlCockPit: '',
        urlSafety: '',
        urlLogin: '',
        urlLoginOpinion: '',
        adobeScript: '',
        makeLogoCatalogo: '',
        bannerPJUrl: '',
        sellerShieldImg: '',
        urlHotDealRegulation: '',
        urlHotDealImages: '',
        urlMapSite: '',
        urlPrivacyPolicy: '',
        urltermSOfUse: '',
        urlAboutThUseOfCookies: '',
        urlConsumerProtectionCode: '',
        urlImgS3: '',
        urlSafe: '',
        urlAttendance: '',
        urlFavorit: '',
        cookieJwt: '',
        userToken: '',
        urlInspected: '',
    };
    switch (_config.getEnv()) {
        case 'dev':
        case 'dev2':
            _c.urlApi = 'https://hportal.webmotors.com.br/api/';
            _c.urlApiServer = 'http://localhost:60385/v1/';
            _c.urlApiSantander = 'http://localhost/WebMotors.Api/santanderservices/';
            _c.urlApiSantanderServer = 'http://localhost/WebMotors.Api/santanderservices/';
            _c.urlWebApp = 'https://hportal.webmotors.com.br/';
            _c.photosBikeUrlNew = 'https://himage.webmotors.com.br/_fotos/AnuncioMotoNovos/';
            _c.photosBikeUrlUsed = 'https://himage.webmotors.com.br/_fotos/AnuncioMotoUsados/';
            _c.photosUrlUsed = 'https://image.webmotors.com.br/_fotos/AnuncioUsados/';
            _c.photosUrlNew = 'https://himage.webmotors.com.brf_fotos/AnuncioNovos/';
            _c.urlCertifiedPurchase =
                'https://hportal.webmotors.com.br/carros/estoque?tipoveiculo=carros&compracertificada=compra%20certificada';
            _c.urlSellMyCar = 'https://hportal.webmotors.com.br/vender/';
            _c.urlSellMyBike = 'https://hportal.webmotors.com.br/vender/moto';
            _c.urlTableFipe = 'http://localhost:3000';
            _c.urlKM = 'https://hportal.webmotors.com.br/catalogo';
            _c.urlFinancig = 'https://hportal.webmotors.com.br/financiamento/';
            _c.urlConsortium = 'https://consorcio.webmotors.com.br/';
            _c.urlPortal = 'https://hportal.webmotors.com.br/wm1';
            _c.urlNewsWM1 = 'https://hportal.webmotors.com.br/wm1/noticias';
            _c.urlNewsWM1Tests = 'https://hportal.webmotors.com.br/wm1/testes/';
            _c.urlNewsWM1Comparative = 'https://hportal.webmotors.com.br/wm1/comparativos/';
            _c.urlNewsWM1Videos = 'https://hportal.webmotors.com.br/wm1/videos-de-carros-e-motos/';
            _c.urlNewsWM1Motorcycles = 'https://hportal.webmotors.com.br/wm1/motos/';
            _c.urlNewsWM1Secrets = 'https://hportal.webmotors.com.br/wm1/segredos-auto/';
            _c.urlNewsWM1Tips = 'https://hportal.webmotors.com.br/wm1/dicas/';
            _c.urlNewsWM1Pocket = 'https://hportal.webmotors.com.br/wm1/dinheiro-e-economia/';
            _c.urlMyAdverts = 'https://hportal.webmotors.com.br/garagem/';
            _c.urlEditProfile = 'https://hportal.webmotors.com.br/garagem/perfil';
            _c.urlMyNegotiations = 'https://hportal.webmotors.com.br/garagem/propostas/compra';
            _c.urlChat = 'https://www.webmotors.com.br/garagem/propostas?nps=true';
            _c.urlProducts = 'https://hportal.webmotors.com.br/garagem/produtos';
            _c.urlPosts = 'https://hportal.webmotors.com.br/garagem/propostas/compra';
            _c.urlAdvancedSearch = 'https://hportal.webmotors.com.br/carros/estoque';
            _c.urlUsedOrNewCars = 'https://hportal.webmotors.com.br/carros-usados/estoque';
            _c.urlNewCars = 'https://hportal.webmotors.com.br/carros-novos/estoque';
            _c.urlUsedOrNewMotorbikes = 'https://hportal.webmotors.com.br/motos-usadas/estoque';
            _c.urlNewMotorsbike = 'https://hportal.webmotors.com.br/motos-novas/estoque';
            _c.urlAutoPayment = 'https://autopago.webmotors.com.br';
            _c.urlManageMyAdvertising = 'https://hportal.webmotors.com.br/garagem/';
            _c.urlCockPit = 'https://hml.cockpit.com.br/';
            _c.urlYourStore = 'https://ajuda.cockpit.com.br/hc/pt-br/';
            _c.urlSafety = 'https://wwww.webmotors.com.br/seguranca/';
            _c.urlInspected = 'https://hportal.webmotors.com.br/carros/estoque?Oportunidades=Vistoriado';
            _c.urlContatcUs = 'https://ajuda.webmotors.com.br/hc/pt-br/';
            _c.urlLogin = 'https://hportal.webmotors.com.br/login?r=https://localhost:8080/catalogo/';
            _c.urlLoginOpinion = 'https://hportal.webmotors.com.br/login?r=https://localhost:8080/catalogo/opiniao/';
            _c.userProperties = 'webmotors.user.properties';
            _c.cookieJwt = 'webmotors.jwt.token.hk';
            _c.adobeScript =
                '<script src="//assets.adobedtm.com/launch-EN6759836e605b42679345423e9ff036e6-staging.min.js" async></script>';
            _c.makeLogoCatalogo = 'https://www.webmotors.com.br/aplicativos/logos/';
            _c.bannerPJUrl = 'https://himage.webmotors.com.br/_banner//';
            _c.userToken = 'webmotors.auth.token';
            _c.sellerShieldImg = 'https://s3.amazonaws.com/webmotors/blindagem-fotos/hml/';
            _c.urlHotDealRegulation = 'https://s3.amazonaws.com/webmotorshub/HK/Feirao/clientes/';
            _c.urlHotDealImages = 'https://hfotos.webmotors.com.br/_fotos//Feirao/clientes/_portal/';
            _c.urlMapSite = 'http://localhost:8080/comum/mapasite';
            _c.urlPrivacyPolicy = 'https://institucional.webmotors.com.br/politica-de-privacidade';
            _c.urltermSOfUse = 'https://institucional.webmotors.com.br/termos-de-uso';
            _c.urlAboutThUseOfCookies = 'https://institucional.webmotors.com.br/sobre-o-uso-de-cookies';
            _c.urlConsumerProtectionCode = 'https://cdn.webmotors.com.br/webmotors/Content/pdf/cdc.pdf?v=32673';
            _c.urlImgS3 = 'https://catalogo.webmotors.com.br/imagens/dev/portal/';
            _c.urlSafe = 'https://seguro.webmotors.com.br/';
            _c.urlAttendance = 'https://atendimento.webmotors.com.br/';
            _c.urlFavorit = 'https://hportal.webmotors.com.br/garagem/favoritos?nps=true';
            break;
        case 'hml':
            _c.urlApi = 'https://hportal.webmotors.com.br/api/';
            _c.urlApiServer = 'https://wvusdhfp4l.execute-api.us-east-1.amazonaws.com/hml/';
            _c.urlApiSantander = 'https://hportal.webmotors.com.br/pf/santanderservices/';
            _c.urlApiSantanderServer = 'https://hportal.webmotors.com.br/pf/santanderservices/';
            _c.urlWebApp = 'https://hportal.webmotors.com.br/';
            _c.photosBikeUrlNew = 'https://himage.webmotors.com.brr/_fotos/AnuncioMotoNovos/';
            _c.photosBikeUrlUsed = 'https://himage.webmotors.com.br/_fotos/AnuncioMotoUsados/';
            _c.photosUrlUsed = 'https://himage.webmotors.com.br/_fotos/AnuncioUsados/';
            _c.photosUrlNew = 'https://himage.webmotors.com.br/_fotos/AnuncioNovos/';
            _c.urlCertifiedPurchase =
                'https://hportal.webmotors.com.br/carros/estoque?tipoveiculo=carros&compracertificada=compra%20certificada';
            _c.urlSellMyCar = 'https://hportal.webmotors.com.br/vender/';
            _c.urlSellMyBike = 'https://hportal.webmotors.com.br/vender/moto';
            _c.urlTableFipe = 'https://hportal.webmotors.com.br/tabela-fipe';
            _c.urlKM = 'https://hportal.webmotors.com.br/catalogo';
            _c.urlFinancig = 'https://hportal.webmotors.com.br/financiamento/';
            _c.urlConsortium = 'https://consorcio.webmotors.com.br/';
            _c.urlPortal = 'https://hportal.webmotors.com.br/wm1';
            _c.urlNewsWM1 = 'https://hportal.webmotors.com.br/wm1/noticias';
            _c.urlNewsWM1Tests = 'https://hportal.webmotors.com.br/wm1/testes/';
            _c.urlNewsWM1Comparative = 'https://hportal.webmotors.com.br/wm1/comparativos/';
            _c.urlNewsWM1Videos = 'https://hportal.webmotors.com.br/wm1/videos-de-carros-e-motos/';
            _c.urlNewsWM1Motorcycles = 'https://hportal.webmotors.com.br/wm1/motos/';
            _c.urlNewsWM1Secrets = 'https://hportal.webmotors.com.br/wm1/segredos-auto/';
            _c.urlNewsWM1Tips = 'https://hportal.webmotors.com.br/wm1/dicas/';
            _c.urlNewsWM1Pocket = 'https://hportal.webmotors.com.br/wm1/dinheiro-e-economia/';
            _c.urlMyAdverts = 'https://hportal.webmotors.com.br/garagem/';
            _c.urlEditProfile = 'https://hportal.webmotors.com.br/garagem/perfil';
            _c.urlMyNegotiations = 'https://hportal.webmotors.com.br/garagem/propostas/compra';
            _c.urlChat = 'https://hportal.webmotors.com.br/garagem/propostas?nps=true';
            _c.urlProducts = 'https://hportal.webmotors.com.br/garagem/produtos';
            _c.urlPosts = 'https://hportal.webmotors.com.br/garagem/propostas/compra';
            _c.urlAdvancedSearch = 'https://hportal.webmotors.com.br/carros/estoque';
            _c.urlUsedOrNewCars = 'https://hportal.webmotors.com.br/carros-usados/estoque';
            _c.urlNewCars = 'https://hportal.webmotors.com.br/carros-novos/estoque';
            _c.urlUsedOrNewMotorbikes = 'https://hportal.webmotors.com.br/motos-usadas/estoque';
            _c.urlNewMotorsbike = 'https://hportal.webmotors.com.br/motos-novas/estoque';
            _c.urlInspected = 'https://hportal.webmotors.com.br/carros/estoque?Oportunidades=Vistoriado';
            _c.urlAutoPayment = 'https://autopago.webmotors.com.br';
            _c.urlManageMyAdvertising = 'https://hportal.webmotors.com.br/garagem/';
            _c.urlCockPit = 'https://hml.cockpit.com.br/';
            _c.urlYourStore = 'https://ajuda.cockpit.com.br/hc/pt-br/';
            _c.urlSafety = 'https://www.webmotors.com.br/seguranca/';
            _c.urlContatcUs = 'https://ajuda.webmotors.com.br/hc/pt-br/';
            _c.urlLogin = 'https://hportal.webmotors.com.br/login?r=https://hportal.webmotors.com.br/catalogo/';
            _c.urlLoginOpinion =
                'https://hportal.webmotors.com.br/login?r=https://hportal.webmotors.com.br/catalogo/opiniao/';
            _c.userProperties = 'webmotors.user.properties';
            _c.cookieJwt = 'webmotors.jwt.token.hk';
            _c.adobeScript =
                '<script src="//assets.adobedtm.com/launch-EN6759836e605b42679345423e9ff036e6-staging.min.js" async></script>';
            _c.makeLogoCatalogo = 'https://www.webmotors.com.br/aplicativos/logos/';
            _c.bannerPJUrl = 'https://himage.webmotors.com.br/_banner//';
            _c.userToken = 'webmotors.auth.token.hk';
            _c.sellerShieldImg = 'https://s3.amazonaws.com/webmotors/blindagem-fotos/hml/';
            _c.urlHotDealRegulation = 'https://s3.amazonaws.com/webmotorshub/HK/Feirao/clientes/';
            _c.urlHotDealImages = 'https://hfotos.webmotors.com.br/_fotos//Feirao/clientes/_portal/';
            _c.urlMapSite = 'https://hportal.webmotors.com.br/comum/mapasite';
            _c.urlPrivacyPolicy = 'https://institucional.webmotors.com.br/politica-de-privacidade';
            _c.urltermSOfUse = 'https://institucional.webmotors.com.br/termos-de-uso';
            _c.urlAboutThUseOfCookies = 'https://institucional.webmotors.com.br/sobre-o-uso-de-cookies';
            _c.urlConsumerProtectionCode = 'https://cdn.webmotors.com.br/webmotors/Content/pdf/cdc.pdf?v=32673';
            _c.urlImgS3 = 'https://catalogo.webmotors.com.br/imagens/hk/portal/';
            _c.urlSafe = 'https://seguro.webmotors.com.br/';
            _c.urlAttendance = 'https://atendimento.webmotors.com.br/';
            _c.urlFavorit = 'https://hportal.webmotors.com.br/garagem/favoritos?nps=true';
            break;
        case 'azl':
            _c.urlApi = 'https://azulportal.webmotors.com.br/api/';
            _c.urlApiServer = 'https://wvusdhfp4l.execute-api.us-east-1.amazonaws.com/azl/';
            _c.urlApiSantander = 'https://azulportal.webmotors.com.br/pf/santanderservices/';
            _c.urlApiSantanderServer = 'https://azulportal.webmotors.com.br/pf/santanderservices/';
            _c.urlWebApp = 'https://azulportal.webmotors.com.br/';
            _c.photosBikeUrlNew = 'https://image.webmotors.com.br/_fotos/AnuncioMotoNovos/';
            _c.photosBikeUrlUsed = 'https://image.webmotors.com.br/_fotos/AnuncioMotoUsados/';
            _c.photosUrlUsed = 'https://image.webmotors.com.br/_fotos/AnuncioUsados/';
            _c.photosUrlNew = 'https://image.webmotors.com.br/_fotos/AnuncioNovos/';
            _c.urlCertifiedPurchase =
                'https://www.webmotors.com.br/carros/estoque?tipoveiculo=carros&compracertificada=compra%20certificada';
            _c.urlSellMyCar = 'https://azulportal.webmotors.com.br/vender/';
            _c.urlSellMyBike = 'https://azulportal.webmotors.com.br/vender/moto';
            _c.urlTableFipe = 'https://azulportal.webmotors.com.br/tabela-fipe';
            _c.urlKM = 'https://azulportal.webmotors.com.br/catalogo';
            _c.urlFinancig = 'https://azulportal.webmotors.com.br/financiamento/';
            _c.urlConsortium = 'https://consorcio.webmotors.com.br/';
            _c.urlPortal = 'https://azulportal.webmotors.com.br/wm1';
            _c.urlNewsWM1 = 'https://azulportal.webmotors.com.br/wm1/noticias';
            _c.urlNewsWM1Tests = 'https://azulportal.webmotors.com.br/wm1/testes/';
            _c.urlNewsWM1Comparative = 'https://azulportal.webmotors.com.br/wm1/comparativos/';
            _c.urlNewsWM1Videos = 'https://azulportal.webmotors.com.br/wm1/videos-de-carros-e-motos/';
            _c.urlNewsWM1Motorcycles = 'https://azulportal.webmotors.com.br/wm1/motos/';
            _c.urlNewsWM1Secrets = 'https://azulportal.webmotors.com.br/wm1/segredos-auto/';
            _c.urlNewsWM1Tips = 'https://azulportal.webmotors.com.br/wm1/dicas/';
            _c.urlNewsWM1Pocket = 'https://azulportal.webmotors.com.br/wm1/dinheiro-e-economia/';
            _c.urlMyAdverts = 'https://azulportal.webmotors.com.br/garagem/';
            _c.urlEditProfile = 'https://azulportal.webmotors.com.br/garagem/perfil';
            _c.urlMyNegotiations = 'https://azulportal.webmotors.com.br/garagem/propostas/compra';
            _c.urlChat = 'https://azulportal.webmotors.com.br/garagem/propostas?nps=true';
            _c.urlProducts = 'https://azulportal.webmotors.com.br/garagem/produtos';
            _c.urlPosts = 'https://azulportal.webmotors.com.br/garagem/propostas/compra';
            _c.urlAdvancedSearch = 'https://azulportal.webmotors.com.br/carros/estoque';
            _c.urlUsedOrNewCars = 'https://azulportal.webmotors.com.br/carros-usados/estoque';
            _c.urlNewCars = 'https://azulportal.webmotors.com.br/carros-novos/estoque';
            _c.urlUsedOrNewMotorbikes = 'https://azulportal.webmotors.com.br/motos/estoque';
            _c.urlNewMotorsbike = 'https://azulportal.webmotors.com.br/motos-novas/estoque';
            _c.urlInspected = 'https://azulportal.webmotors.com.br/carros/estoque?Oportunidades=Vistoriado';
            _c.urlAutoPayment = 'https://autopago.webmotors.com.br';
            _c.urlManageMyAdvertising = 'https://azulportal.webmotors.com.br/garagem/';
            _c.urlCockPit = 'https://azl.cockpit.com.br/';
            _c.urlYourStore = 'https://ajuda.cockpit.com.br/hc/pt-br/';
            _c.urlSafety = 'https://www.webmotors.com.br/seguranca/';
            _c.urlContatcUs = 'https://ajuda.webmotors.com.br/hc/pt-br/';
            _c.urlLogin = 'https://azulportal.webmotors.com.br/login?r=https://azulportal.webmotors.com.br/catalogo/';
            _c.urlLoginOpinion =
                'https://azulportal.webmotors.com.br/login?r=https://azulportal.webmotors.com.br/catalogo/opiniao/';
            _c.adobeScript =
                '<script src="//assets.adobedtm.com/launch-ENa8ccb19d1824443d8c0fde67006c1d04.min.js" async></script>';
            _c.makeLogoCatalogo = 'https://www.webmotors.com.br/aplicativos/logos/';
            _c.bannerPJUrl = 'https://img.webmotors.com.br/_banner/';
            _c.userToken = 'webmotors.auth.token.azul';
            _c.cookieJwt = 'webmotors.jwt.token';
            _c.sellerShieldImg = 'https://www.webmotors.com.br/img/blindagem/';
            _c.urlHotDealImages = 'https://fotos.webmotors.com.br/_fotos//Feirao/clientes/_portal/';
            _c.urlHotDealRegulation = 'https://s3.amazonaws.com/webmotorshub/Feirao/clientes/';
            _c.urlMapSite = 'https://azulportal.webmotors.com.br/comum/mapasite';
            _c.urlPrivacyPolicy = 'https://institucional.webmotors.com.br/politica-de-privacidade';
            _c.urltermSOfUse = 'https://institucional.webmotors.com.br/termos-de-uso';
            _c.urlAboutThUseOfCookies = 'https://institucional.webmotors.com.br/sobre-o-uso-de-cookies';
            _c.urlConsumerProtectionCode = 'https://cdn.webmotors.com.br/webmotors/Content/pdf/cdc.pdf?v=32673';
            _c.urlImgS3 = 'https://catalogo.webmotors.com.br/imagens/azul/portal/';
            _c.urlSafe = 'https://seguro.webmotors.com.br/';
            _c.urlAttendance = 'https://atendimento.webmotors.com.br/';
            _c.urlFavorit = 'https://azulportal.webmotors.com.br/garagem/favoritos?nps=true';
            break;
        case 'prd':
            _c.urlApi = 'https://www.webmotors.com.br/api/';
            _c.urlApiServer = 'https://wvusdhfp4l.execute-api.us-east-1.amazonaws.com/prd/';
            _c.urlApiSantander = 'https://www.webmotors.com.br/pf/santanderservices/';
            _c.urlApiSantanderServer = 'https://www.webmotors.com.br/pf/santanderservices/';
            _c.urlWebApp = 'https://www.webmotors.com.br/';
            _c.photosBikeUrlNew = 'https://image.webmotors.com.br/_fotos/AnuncioMotoNovos/';
            _c.photosBikeUrlUsed = 'https://image.webmotors.com.br/_fotos/AnuncioMotoUsados/';
            _c.photosUrlUsed = 'https://image.webmotors.com.br/_fotos/AnuncioUsados/';
            _c.photosUrlNew = 'https://image.webmotors.com.br/_fotos/AnuncioNovos/';
            _c.urlCertifiedPurchase =
                'https://www.webmotors.com.br/carros/estoque?tipoveiculo=carros&compracertificada=compra%20certificada';
            _c.urlSellMyCar = 'https://www.webmotors.com.br/vender/';
            _c.urlSellMyBike = 'https://www.webmotors.com.br/vender/moto';
            _c.urlTableFipe = 'https://www.webmotors.com.br/tabela-fipe';
            _c.urlKM = 'https://www.webmotors.com.br/catalogo';
            _c.urlFinancig = 'https://www.webmotors.com.br/financiamento/';
            _c.urlConsortium = 'https://consorcio.webmotors.com.br/';
            _c.urlPortal = 'https://www.webmotors.com.br/wm1';
            _c.urlNewsWM1 = 'https://www.webmotors.com.br/wm1/noticias';
            _c.urlNewsWM1Tests = 'https://www.webmotors.com.br/wm1/testes/';
            _c.urlNewsWM1Comparative = 'https://www.webmotors.com.br/wm1/comparativos/';
            _c.urlNewsWM1Videos = 'https://www.webmotors.com.br/wm1/videos-de-carros-e-motos/';
            _c.urlNewsWM1Motorcycles = 'https://www.webmotors.com.br/wm1/motos/';
            _c.urlNewsWM1Secrets = 'https://www.webmotors.com.br/wm1/segredos-auto/';
            _c.urlNewsWM1Tips = 'https://www.webmotors.com.br/wm1/dicas/';
            _c.urlNewsWM1Pocket = 'https://www.webmotors.com.br/wm1/dinheiro-e-economia/';
            _c.urlMyAdverts = 'https://www.webmotors.com.br/garagem/';
            _c.urlEditProfile = 'https://www.webmotors.com.br/garagem/perfil';
            _c.urlMyNegotiations = 'https://www.webmotors.com.br/garagem/propostas/compra';
            _c.urlChat = 'https://www.webmotors.com.br/garagem/propostas?nps=true';
            _c.urlProducts = 'https://www.webmotors.com.br/garagem/produtos';
            _c.urlPosts = 'https://www.webmotors.com.br/garagem/propostas/compra';
            _c.urlAdvancedSearch = 'https://www.webmotors.com.br/carros/estoque';
            _c.urlUsedOrNewCars = 'https://www.webmotors.com.br/carros-usados/estoque';
            _c.urlNewCars = 'https://www.webmotors.com.br/carros-novos/estoque';
            _c.urlUsedOrNewMotorbikes = 'https://www.webmotors.com.br/motos/estoque';
            _c.urlNewMotorsbike = 'https://www.webmotors.com.br/motos-novas/estoque';
            _c.urlInspected = 'https://www.webmotors.com.br/carros/estoque?Oportunidades=Vistoriado';
            _c.urlAutoPayment = 'https://autopago.webmotors.com.br';
            _c.urlManageMyAdvertising = 'https://www.webmotors.com.br/garagem/';
            _c.urlCockPit = 'https://cockpit.webmotors.com.br/';
            _c.urlYourStore = 'https://ajuda.cockpit.com.br/hc/pt-br/';
            _c.urlSafety = 'https://www.webmotors.com.br/seguranca/';
            _c.urlContatcUs = 'https://ajuda.webmotors.com.br/hc/pt-br/';
            _c.urlGeneralQuestions = 'https://ajuda.webmotors.com.br';
            _c.urlHowToSell = 'https://atendimento.webmotors.com.br/como-vender-seu-veiculo';
            _c.urlHowToBuy = 'https://atendimento.webmotors.com.br/como-comprar-seu-veiculo';
            _c.urlLegalPerson =
                'https://ajuda.cockpit.com.br/hc/articles/360057303832-Quem-pode-anunciar-como-pessoa-juridica';
            _c.urlLogin = 'https://www.webmotors.com.br/login?r=https://www.webmotors.com.br/catalogo/';
            _c.urlLoginOpinion = 'https://www.webmotors.com.br/login?r=https://www.webmotors.com.br/catalogo/opiniao/';
            _c.adobeScript =
                '<script src="//assets.adobedtm.com/launch-ENa8ccb19d1824443d8c0fde67006c1d04.min.js" async></script>';
            _c.makeLogoCatalogo = 'https://www.webmotors.com.br/aplicativos/logos/';
            _c.bannerPJUrl = 'https://img.webmotors.com.br/_banner/';
            _c.userToken = 'webmotors.auth.token';
            _c.cookieJwt = 'webmotors.jwt.token';
            _c.sellerShieldImg = '/img/blindagem/';
            _c.urlHotDealImages = 'https://fotos.webmotors.com.br/_fotos//Feirao/clientes/_portal/';
            _c.urlHotDealRegulation = 'https://s3.amazonaws.com/webmotorshub/Feirao/clientes/';
            _c.urlMapSite = 'https://www.webmotors.com.br/comum/mapasite';
            _c.urlPrivacyPolicy = 'https://institucional.webmotors.com.br/politica-de-privacidade';
            _c.urltermSOfUse = 'https://institucional.webmotors.com.br/termos-de-uso';
            _c.urlAboutThUseOfCookies = 'https://institucional.webmotors.com.br/sobre-o-uso-de-cookies';
            _c.urlConsumerProtectionCode = 'https://cdn.webmotors.com.br/webmotors/Content/pdf/cdc.pdf?v=32673';
            _c.urlImgS3 = 'https://catalogo.webmotors.com.br/imagens/prod/portal/';
            _c.urlSafe = 'https://seguro.webmotors.com.br/';
            _c.urlAttendance = 'https://atendimento.webmotors.com.br/';
            _c.urlFavorit = 'https://www.webmotors.com.br/garagem/favoritos?nps=true';
            break;

        default:
            _c.urlApi = 'https://www.webmotors.com.br/api/';
            _c.urlApiServer = 'https://wvusdhfp4l.execute-api.us-east-1.amazonaws.com/prd/';
            _c.urlApiSantander = 'https://www.webmotors.com.br/pf/santanderservices/';
            _c.urlApiSantanderServer = 'https://www.webmotors.com.br/pf/santanderservices/';
            _c.urlWebApp = 'https://www.webmotors.com.br/';
            _c.photosBikeUrlNew = 'https://image.webmotors.com.br/_fotos/AnuncioMotoNovos/';
            _c.photosBikeUrlUsed = 'https://image.webmotors.com.br/_fotos/AnuncioMotoUsados/';
            _c.photosUrlUsed = 'https://image.webmotors.com.br/_fotos/AnuncioUsados/';
            _c.photosUrlNew = 'https://image.webmotors.com.br/_fotos/AnuncioNovos/';
            _c.urlCertifiedPurchase =
                'https://www.webmotors.com.br/carros/estoque?tipoveiculo=carros&compracertificada=compra%20certificada';
            _c.urlSellMyCar = 'https://www.webmotors.com.br/vender/';
            _c.urlSellMyBike = 'https://www.webmotors.com.br/vender/moto';
            _c.urlTableFipe = 'https://www.webmotors.com.br/tabela-fipe';
            _c.urlKM = 'https://www.webmotors.com.br/catalogo';
            _c.urlFinancig = 'https://www.webmotors.com.br/financiamento/';
            _c.urlConsortium = 'https://consorcio.webmotors.com.br/';
            _c.urlNewsWM1 = 'https://www.webmotors.com.br/wm1/noticias';
            _c.urlNewsWM1Tests = 'https://www.webmotors.com.br/wm1/testes/';
            _c.urlNewsWM1Comparative = 'https://www.webmotors.com.br/wm1/comparativos/';
            _c.urlNewsWM1Videos = 'https://www.webmotors.com.br/wm1/videos-de-carros-e-motos/';
            _c.urlNewsWM1Motorcycles = 'https://www.webmotors.com.br/wm1/motos/';
            _c.urlNewsWM1Secrets = 'https://www.webmotors.com.br/wm1/segredos-auto/';
            _c.urlNewsWM1Tips = 'https://www.webmotors.com.br/wm1/dicas/';
            _c.urlNewsWM1Pocket = 'https://www.webmotors.com.br/wm1/dinheiro-e-economia/';
            _c.urlMyAdverts = 'https://www.webmotors.com.br/garagem/';
            _c.urlEditProfile = 'https://www.webmotors.com.br/garagem/perfil';
            _c.urlMyNegotiations = 'https://www.webmotors.com.br/garagem/propostas/compra';
            _c.urlChat = 'https://www.webmotors.com.br/garagem/propostas?nps=true';
            _c.urlProducts = 'https://www.webmotors.com.br/garagem/produtos';
            _c.urlPosts = 'https://www.webmotors.com.br/garagem/propostas/compra';
            _c.urlAdvancedSearch = 'https://www.webmotors.com.br/carros/estoque';
            _c.urlUsedOrNewCars = 'https://www.webmotors.com.br/carros-usados/estoque';
            _c.urlNewCars = 'https://www.webmotors.com.br/carros-novos/estoque';
            _c.urlUsedOrNewMotorbikes = 'https://www.webmotors.com.br/motos/estoque';
            _c.urlNewMotorsbike = 'https://www.webmotors.com.br/motos-novas/estoque';
            _c.urlInspected = 'https://www.webmotors.com.br/carros/estoque?Oportunidades=Vistoriado';
            _c.urlAutoPayment = 'https://autopago.webmotors.com.br';
            _c.urlManageMyAdvertising = 'https://www.webmotors.com.br/garagem/';
            _c.urlCockPit = 'https://cockpit.webmotors.com.br/';
            _c.urlYourStore = 'https://ajuda.cockpit.com.br/hc/pt-br/';
            _c.urlSafety = 'https://www.webmotors.com.br/seguranca/';
            _c.urlContatcUs = 'https://ajuda.webmotors.com.br/hc/pt-br/';
            _c.urlGeneralQuestions = 'https://ajuda.webmotors.com.br';
            _c.urlHowToSell = 'https://atendimento.webmotors.com.br/como-vender-seu-veiculo';
            _c.urlHowToBuy = 'https://atendimento.webmotors.com.br/como-comprar-seu-veiculo';
            _c.urlLegalPerson =
                'https://ajuda.cockpit.com.br/hc/articles/360057303832-Quem-pode-anunciar-como-pessoa-juridica';
            _c.urlLogin = 'https://www.webmotors.com.br/login?r=https://www.webmotors.com.br/catalogo/';
            _c.urlLoginOpinion = 'https://www.webmotors.com.br/login?r=https://www.webmotors.com.br/catalogo/opiniao/';
            _c.adobeScript =
                '<script src="//assets.adobedtm.com/launch-ENa8ccb19d1824443d8c0fde67006c1d04.min.js" async></script>';
            _c.makeLogoCatalogo = 'https://www.webmotors.com.br/aplicativos/logos/';
            _c.bannerPJUrl = 'https://img.webmotors.com.br/_banner/';
            _c.userToken = 'webmotors.auth.token';
            _c.cookieJwt = 'webmotors.jwt.token';
            _c.sellerShieldImg = '/img/blindagem/';
            _c.urlHotDealImages = 'https://fotos.webmotors.com.br/_fotos//Feirao/clientes/_portal/';
            _c.urlHotDealRegulation = 'https://s3.amazonaws.com/webmotorshub/Feirao/clientes/';
            _c.urlMapSite = 'https://www.webmotors.com.br/comum/mapasite';
            _c.urlPrivacyPolicy = 'https://institucional.webmotors.com.br/politica-de-privacidade';
            _c.urltermSOfUse = 'https://institucional.webmotors.com.br/termos-de-uso';
            _c.urlAboutThUseOfCookies = 'https://institucional.webmotors.com.br/sobre-o-uso-de-cookies';
            _c.urlConsumerProtectionCode = 'https://cdn.webmotors.com.br/webmotors/Content/pdf/cdc.pdf?v=32673';
            _c.urlImgS3 = 'https://catalogo.webmotors.com.br/imagens/prod/portal/';
            _c.urlSafe = 'https://seguro.webmotors.com.br/';
            _c.urlAttendance = 'https://atendimento.webmotors.com.br/';
            _c.urlFavorit = 'https://www.webmotors.com.br/garagem/favoritos?nps=true';
            break;
    }
    if (_config.getEnv() == 'dev2') {
        _c.urlApi = 'https://hportal.webmotors.com.br/api/';
        _c.urlApiServer = 'https://hportal.webmotors.com.br/api/';
    }
    return _c;
};

export const config = configs();
